import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n    font-size: 16px;\n  "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n  width: 100%;\n  opacity: 0.5;\n  ", "\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n    font-size: 14px;\n    margin-right: 20px;\n    display: inline-block;\n  "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n    font-size: 14px;\n    margin-right: 50px;\n  "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n    font-size: 16px;\n  "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n  margin-bottom: 1.5rem;\n  padding-bottom: 4px;\n  border-bottom: ", ";\n  opacity: ", ";\n  font-size: 20px;\n  line-height: 14px;\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    flex-direction: row;\n    height: 100%;\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 150px;\n  ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    width: 135%;\n    justify-content: flex-start;\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    height: 100%;\n    flex-direction: row;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    height: 473px;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  height: 583px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { media, styled } from "@styles";
export var Wrapper = styled.div(_templateObject(), media.xxLargeScreen(_templateObject2()), media.xLargeScreen(_templateObject3()), media.smallScreen(_templateObject4()));
export var MenuItems = styled.div(_templateObject5(), media.xLargeScreen(_templateObject6()));
export var MenuItem = styled.span(_templateObject7(), function (props) {
  return props.active ? "2px solid ".concat(props.theme.colors.red) : "none";
}, function (props) {
  return props.active ? "1" : "0.8";
}, media.xxLargeScreen(_templateObject8()), media.xLargeScreen(_templateObject9()), media.mediumScreen(_templateObject10()));
export var MenuItemLogOut = styled.div(_templateObject11(), media.xxLargeScreen(_templateObject12()));